import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/styling.js";

import App from "./App";
import AdminRoot from "./admin/AdminRoot";
import reportWebVitals from "./reportWebVitals";

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import AuthWrapper from "./components/auth/authWrapper";
import ModalContainer from "./components/common/modal/modalContainer.jsx";
import { clearBrowserAuthSession } from "./utils/sessionLogout";

import "./utils/notificationManager";

const AuthApp = AuthWrapper(App);

const LogoutRedirect = () => {
  clearBrowserAuthSession();
  return <Redirect from="/logout" exact to="/login" />;
};

const darkMode = localStorage.getItem("darkMode") === "true";
if (darkMode) {
  document.body.classList.add("dark-mode");
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <Switch>
      <Route
        path="/logout"
        exact
        render={LogoutRedirect}
      />
      <Route
        path="/admin"
        render={(routeProps) => {
          return <AdminRoot {...routeProps} />;
        }}
      />
      <Route
        render={({ history, location }) => {
          return <AuthApp history={history} location={location} />;
        }}
      />
    </Switch>
    <ModalContainer />
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
